import React, { FC } from 'react';
import type { ReportsSummaryMetric } from '../../models';

import './styles.scss';

interface ReportsSummaryProps {
  metrics: ReportsSummaryMetric[];
}

export const ReportsSummary: FC<ReportsSummaryProps> = ({
  metrics,
}: ReportsSummaryProps) => (
  <div className="prov-reports-summary">
    {metrics.map(({ caption, label, value }: ReportsSummaryMetric) => (
      <div className="prov-reports-summary__item" key={label}>
        <span>{label}</span>
        <strong>{value}</strong>
        {caption && <small>{caption}</small>}
      </div>
    ))}
  </div>
);
